<template>
  <div id="app">
    <router-view/>

    <div id="recaptcha" class="g-recaptcha"
      :data-sitekey="recaptchaKey"
      data-callback="recaptchaCallback"
      data-size="invisible">
    </div>

  </div>
</template>

<script>
import {env} from '@/env'

export default {
  name: 'App',
  data () {
    return {
      recaptchaKey : env.recaptchaKey,
      keepCheckingHeightInterval : null,
    }
  },
  mounted(){

    this.initFirebase();
    this.squareCalculation();
    this.keepCheckingHeight();
    this.checkCookies();
    this.mobileChecking();
    this.preloadWebsiteAudioBuffer();

  },
  beforeDestroy() {

  },
  methods:{
    keepCheckingHeight(){
      let self = this;
      let currentHeight = 0;
      if(self.keepCheckingHeightInterval != null){
        clearInterval(self.keepCheckingHeightInterval);
        self.keepCheckingHeightInterval = null;
      }
      self.keepCheckingHeightInterval = setInterval(() => {
        if(window.innerHeight != currentHeight){
          currentHeight = window.innerHeight;

          let isSkipCalculate = false;
          const emailInput = self.getElement("home_emailInput");
          if(emailInput != null){
            if(document.activeElement === emailInput){
              isSkipCalculate = true;
            }
          }

          if(!isSkipCalculate){
            self.squareCalculation();
          }
        }
      }, 500);
    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue